import Marked from "marked-react";
import type { CustomReactRenderer } from "marked-react/dist/ReactRenderer";
import React from "react";

export const renderer: CustomReactRenderer = {
  heading(children, level) {
    // TODO: use proper heading font sizes
    const fontSizes = {
      1: "text-5xl md:text-6xl",
      2: "md:text-5xl text-4xl",
      3: "text-4xl",
      4: "text-3xl",
      5: "text-2xl",
      6: "text-xl",
    };
    return React.createElement(`h${level}`, { className: fontSizes[level] }, children);
  },
};

export const Markdown = ({ children }: { children: string }) => (
  <Marked renderer={renderer}>{children}</Marked>
);
